import React, {useRef, useState} from 'react';
import {Modal} from "./modal.jsx";
import Button from "../button/button.jsx";
import {APIProvider, ControlPosition, Map, Marker} from "@vis.gl/react-google-maps";
import {useQuery} from "@tanstack/react-query";
import corporationService from "../../services/web/corporation-service.js";
import {GeocodeAddress} from "../utils/map-utils.jsx";

const ModalAddress = ({open, setOpen, changeLocation, address}) => {
    const markerRef = useRef(undefined);

    const {data: corporation} = useQuery({
        queryFn: () => corporationService.entity(),
        queryKey: ["corporation"]
    });

    const parsedLatitude = parseFloat(address?.latitude);
    const parsedLongitude = parseFloat(address?.longitude);
    const hasValidCoordinates = isFinite(parsedLatitude) && isFinite(parsedLongitude);

    const fallbackLatitude = parseFloat(corporation?.latitude) || 0;
    const fallbackLongitude = parseFloat(corporation?.longitude) || 0;

    const position = {
        lat: hasValidCoordinates ? parsedLatitude : fallbackLatitude,
        lng: hasValidCoordinates ? parsedLongitude : fallbackLongitude
    }

    const onDragEnd = (event) => {
        changeLocation(event.latLng);
    }

    const onClose = () => {
        changeLocation(markerRef.current.getPosition());
        setOpen(false)
    }

    return (
        <Modal open={open} setOpen={setOpen} title={"Mapa"}>
            <Modal.Body className="p-0! !m-0 align-self-center justify-items-center">
                <APIProvider apiKey={corporation?.maps_api_key}>
                    <Map
                        reuseMaps={true}
                        defaultZoom={12}
                        streetViewControl={false}
                        defaultCenter={position}
                        gestureHandling={'greedy'}
                        style={{ height: "calc(-250px + 100vh)", width: "100%" }}
                        mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
                        fullscreenControlOptions={{position: ControlPosition.BOTTOM_RIGHT}}
                    >
                        <GeocodeAddress address={address} changeLocation={changeLocation} parsedLatitude={parsedLatitude}
                                        parsedLongitude={parsedLongitude}/>
                        <Marker
                            position={position}
                            draggable={true}
                            onDragEnd={onDragEnd}
                            ref={markerRef}
                        />
                    </Map>
                </APIProvider>
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" target="primary" onClick={onClose}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalAddress;